import React, { useEffect, useRef, useState } from "react";
import { View, StyleSheet, Animated } from "react-native";
import { STYLES } from "../assets/styles";

const DOT_SIZE = 6;

function Swiper({
  dataArray = [],
  showPagination = true,
  renderItem = () => {},
  style = {},
  scrollTo = 0,
}) {
  const scrollX = useRef(new Animated.Value(0)).current;
  const scrollRef = useRef(null);
  const [viewDim, setViewDim] = useState({ width: 0, height: 0 });

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollToIndex({ index: scrollTo, animated: true });
    }
  }, [scrollTo]);

  const Pagination = ({ scrollX }) => {
    return (
      <View style={styles.dotsContainer}>
        {dataArray.map((_, index) => {
          const width = scrollX.interpolate({
            inputRange: [
              viewDim.width * (index - 1),
              viewDim.width * index,
              viewDim.width * (index + 1),
            ],
            outputRange: [DOT_SIZE, DOT_SIZE * 2, DOT_SIZE],
            extrapolate: "clamp",
          });
          const bgColor = scrollX.interpolate({
            inputRange: [
              viewDim.width * (index - 1),
              viewDim.width * index,
              viewDim.width * (index + 1),
            ],
            outputRange: [
              STYLES.colors.powderWhite,
              STYLES.colors.black,
              STYLES.colors.powderWhite,
            ],
            extrapolate: "clamp",
          });

          return (
            <Animated.View
              key={index + "sld"}
              style={[
                styles.dot,
                {
                  backgroundColor: bgColor,
                  width,
                },
              ]}
            />
          );
        })}
      </View>
    );
  };

  return (
    <>
      {dataArray.length > 0 ? (
        <View
          style={[
            {
              height: "100%",
              backgroundColor: "white",
            },
            style,
          ]}
          onLayout={({ nativeEvent }) => {
            const { width, height } = nativeEvent.layout;
            setViewDim({ width, height });
          }}
        >
          <Animated.FlatList
            data={dataArray}
            ref={(e) => {
              scrollRef.current = e;
            }}
            getItemLayout={(data, index) => ({
              length: viewDim.height,
              offset: viewDim.height * index,
              index,
            })}
            keyExtractor={(_, key) => key + "f"}
            renderItem={({ item, index }) => (
              <View
                key={index + "f"}
                style={{
                  width: viewDim.width,
                  height: viewDim.height,
                }}
              >
                {renderItem({ item, index })}
              </View>
            )}
            pagingEnabled={true}
            horizontal={true}
            showsHorizontalScrollIndicator={false}
            onScroll={Animated.event(
              [{ nativeEvent: { contentOffset: { x: scrollX } } }],
              { useNativeDriver: false }
            )}
            scrollEventThrottle={16}
          />
          {showPagination ? <Pagination scrollX={scrollX} /> : null}
        </View>
      ) : null}
    </>
  );
}

const styles = StyleSheet.create({
  dotsContainer: {
    height: "10%",
    justifyContent: "center",
    flexDirection: "row",
    alignItems: "center",
    position: "absolute",
    width: "100%",
    bottom: 10,
  },
  image: {
    flex: 1,
    resizeMode: "cover",
  },
  dot: {
    height: DOT_SIZE,
    width: DOT_SIZE,
    borderRadius: DOT_SIZE / 2,
    marginHorizontal: 5,
  },
});
export default Swiper;
